import React, { useCallback, useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon } from '@material-ui/icons'

import { DriverDialog } from 'src/modules/supply_chain/components/DriverDialog'
import { DateField, EditImageField, EditProfileField, ValueField } from 'src/components/Table'
import { skuit } from 'src/services/skuit'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
  refetch: () => void
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const DriverDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)

  const guid = obj.data?.guid
  const profileUpload = useCallback(
    (file: File) => {
      return skuit.sc.drivers.uploadProfileImage(guid, file)
    },
    [guid]
  )
  const frontUpload = useCallback(
    (file: File) => {
      return skuit.sc.drivers.uploadFront(guid, file)
    },
    [guid]
  )
  const backUpload = useCallback(
    (file: File) => {
      return skuit.sc.drivers.uploadBack(guid, file)
    },
    [guid]
  )

  return (
    <>
      {updateOpen && (
        <DriverDialog
          open={updateOpen}
          driver={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Driver', onClick: () => setUpdateOpen(true) }],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'firstName', label: 'First Name', renderer: ValueField },
          { id: 'lastName', label: 'Last Name', renderer: ValueField },
          { id: 'email', label: 'Email', renderer: ValueField },
          { id: 'phone', label: 'Phone', renderer: ValueField },
          {
            id: 'profileImage',
            label: 'Profile Image',
            renderer: EditProfileField({ upload: profileUpload, refresh: obj.refetch }),
          },
          { id: 'dlStateCode', label: 'State', renderer: ValueField },
          { id: 'dlNumber', label: 'Number', renderer: ValueField },
          { id: 'dlExpiresOn', label: 'Expiration', renderer: DateField },
          {
            id: 'dlFront',
            label: 'Front',
            renderer: EditImageField({
              key: 'front',
              upload: frontUpload,
              refresh: obj.refetch,
            }),
          },
          {
            id: 'dlBack',
            label: 'Back',
            renderer: EditImageField({
              key: 'back',
              upload: backUpload,
              refresh: obj.refetch,
            }),
          },
        ]}
      />
    </>
  )
}
